import { TableCell, TableRow } from "@mui/material";
import React from "react";
import { ITypeGrid } from "./paginationGrid";
import LoadingComponent from "../loading/loadingComponent";
import ResultNotFoundComponent from "@/main/components/shared/resultNotFound/resultNotFoundComponent";

interface IPaginationLoading {
	typeGrid: ITypeGrid;
}

interface IPaginationNotFound {
	typeGrid: ITypeGrid;
	messageResultNotFound?: string;
}
const COLSPAN_ALL_COLUMNS = 99;

const renderInTableCell = (component: JSX.Element, typeGrid: ITypeGrid) => {
	switch (typeGrid) {
		case "boxGrid":
			return (
				<TableRow>
					<TableCell colSpan={COLSPAN_ALL_COLUMNS}>{component}</TableCell>
				</TableRow>
			);
		default:
			return component;
	}
};

export const PaginationLoading: React.FC<IPaginationLoading> = ({ typeGrid }) => {
	const spinner = <LoadingComponent />;
	return renderInTableCell(spinner, typeGrid);
};

export const PaginationNotFound: React.FC<IPaginationNotFound> = ({ typeGrid, messageResultNotFound }) => {
	const resultNotFound = <ResultNotFoundComponent messageCustom={messageResultNotFound} />;
	return renderInTableCell(resultNotFound, typeGrid);
};
